module.exports = __webpack_public_path__ + "static/media/mob-affi9.4524a4c7.webp";